import { useParams } from "react-router-dom";

import { useFragment } from "@apollo/client";

import { type MyLensesOrganization } from "../../gql-generated/types";
import { organization } from "../api/fragments";

// TODO: Unify Camera Kit and Lens Central organizations
export const useSelectedLensCentralOrganizationNotIncludesCamkitOrgs = (): MyLensesOrganization | null => {
    const { orgId } = useParams<{ orgId?: string }>();
    const { data, complete } = useFragment<MyLensesOrganization>({
        fragment: organization.all,
        fragmentName: "OrganizationAll",
        from: {
            __typename: "MyLensesOrganization",
            id: orgId,
        },
    });

    return complete ? data : null;
};
